import { render, staticRenderFns } from "./H.vue?vue&type=template&id=70ae13a8&scoped=true"
import script from "./H.vue?vue&type=script&lang=js"
export * from "./H.vue?vue&type=script&lang=js"
import style0 from "./H.vue?vue&type=style&index=0&id=70ae13a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae13a8",
  null
  
)

export default component.exports